import "./Alerts.scss";

export const Alerts = () => {
  return <></>;
};
